const Send: React.FC<{ className?: string }> = ({ className = '' }) => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1.92302 9.37004C1.41302 9.16504 1.41902 8.86004 1.95702 8.68104L21.043 2.31904C21.572 2.14304 21.875 2.43904 21.727 2.95704L16.273 22.043C16.123 22.572 15.798 22.596 15.556 22.113L11 13L1.92302 9.37004ZM6.81302 9.17004L12.449 11.425L15.489 17.507L19.035 5.09704L6.81202 9.17004H6.81302Z" />
        </svg>
    );
};

export default Send;
